export default __webpack_public_path__ + "assets/images/bb3e6c43da3008a5ea4c69924d3fd9b1.svg";